import { render, staticRenderFns } from "./PizzaSlider.vue?vue&type=template&id=4322fb9d&"
import script from "./PizzaSlider.vue?vue&type=script&lang=js&"
export * from "./PizzaSlider.vue?vue&type=script&lang=js&"
import style0 from "./PizzaSlider.vue?vue&type=style&index=0&id=4322fb9d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports